<template>
    <div class="bulkAssign">
        <div class="o-ndividualArea">
            <div class="o-ndividualTable assigntab" style="padding-top: 0px;">
                <div class="extra-list-table-outer table_main_content">

                    <div class="tbl-header">
                        <div class="o-calls-table bulk-table-list c-radius3 table_header_black table_1">
                            <div class="calls-table-row">
                                <div class="calls-table-cell tcell_1">
                                    <div class="">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="table_heading th_cell_1">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <dynamicHeader v-for="(item, index) in callAssignmentSettings" :client="client" :columnLabel="item" :sortType="selectedSortType" :key="index"></dynamicHeader>
                            </div>
                        </div>
                    </div>
                    <!-- <v-infinite-scroll 
                        tabindex="1" 
                        id="page-data-focus" 
                        :loading="loading" 
                        @top="onPageChangeScrollUp" 
                        @bottom="onPageChangeScrollDown" 
                        :offset='100' class="tbl-content" 
                        autofocus
                    > -->

                    <v-infinite-scroll
                        id="page-data-focus"
                        ref="scrollContainer"
                        tabindex="1"
                        :loading="loading"
                        :offset="100"
                        class="tbl-content"
                        @bottom="onPageChangeScrollDown"
                        @top="onPageChangeScrollUp"
                    >
                        <div 
                            v-for="(employee, row) in employees" 
                            :key="employee.id" 
                            :style="{'border': '2px solid '+employee.link_color, 'box-shadow': '0px 0px 5px 0px '+employee.link_color}" 
                            class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-radius3 table_1"
                        >
                            <div class="calls-table-row">                               
                                <div class="calls-table-cell tcell_1">
                                    <div class="o-post-logged o-post-logged--table-user">
                                        <div class="o-user-profile-img" :id="'scrollTop'+row">
                                            <img 
                                                v-if="employee.employable&&employee.employable.image&&employee.employable.image != '' && 
                                                employee.employable.image != 'NULL'" :src="(employee.image)"  
                                                id='img-upload'/>
                                            <img 
                                                v-if="employee.employable&&(!employee.employable.image||employee.employable.image == '' || 
                                                employee.employable.image == 'NULL')" 
                                                src="static/assets/images/user1.png" 
                                                id='img-upload'/>
                                        </div>
                                    </div>
                                </div>
                                <dynamicColumns 
                                    v-for="(item, index) in callAssignmentSettings" 
                                    :employee="employee" :columnLabel="item" 
                                    :client="client" :selectedSortType="selectedSortType" 
                                    :date="date" :userDateFormat="userDateFormat" 
                                    :isSteward="isSteward" 
                                    :userTimeFormat="userTimeFormat" 
                                    :key="index">
                                </dynamicColumns>                                                     
                            </div>
                        </div>

                        <div v-if="loading" v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" style="height:50px; z-index:10">
                            <div class="calls-table-row">
                                <div class="calls-table-cell" style="height: 100px;">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="employees.length<=0 && apiData && !loading" v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" style="height: 50px;">
                            <div class="calls-table-row">
                                <div class="calls-table-cell" style="height: 60px;">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <div>Empty Employee List</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-infinite-scroll>
                </div>
                <div class="el-pagination-assign">
                    <el-pagination
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        :total="totalLimit"
                        layout="prev, pager, next"
                        @current-change="onPageChange"
                    />
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import dateTimeConvert from '@/timeConvert&Compare';
    import dynamicColumns from '@/components/calls/assign/DailyScheduleAllEmployeesDynamicColumns';
    import dynamicHeader from '@/components/calls/assign/DailyScheduleAllEmployeesDynamicHeaders';
    import { mapGetters, mapActions} from 'vuex';
    import { global } from '@/global.js';
    import service from '@/services.js';
    import { bus } from '@/main';
    let timeout = null;
    export default {
        components: {
            'dynamicHeader': dynamicHeader,
            'dynamicColumns': dynamicColumns,
        },

        props: {
          date: {
            required: false,
            type: String,
            default: moment().format('YYYY-MM-DD')
          },
          sort: {
            required: false,
            type: String,
            default: 'seniority'
          },
          status: {
            required: false,
            type: String,
            default: 'all'
          },
          skills: {
            required: false,
            type: Array,
            default:() => []
          },
          search: {
            required: false,
            type: String,
            default: ''
          },
          componentName: {
            required: false,
            type: String,
            default: ''
          }
        },

        data() {
            return {
                isSteward: 0,
                timerState: null,
                polling:null,
                currentPage: 1, 
                lastLoadedPage: 0, 
                isFirstPageLoad: false,
                totalLimit:0,
                pageSize:100,
                empProfile: '',
                getBaseURL: '',
                selectedSortType: 'seniority',
                employees: [],
                storeMore: [],
                nextPageUrl: '',
                statusList: [],
                selectedStatusId: '',
                tempStatus: '',
                jobList: [],
                turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                callAssignmentSettings:'',
                map_name: "googleMap",
                addresses:'',
                jobTitle :'',
                loading:true,
                apiData:false,
                searchBoxvalue:'',
                client:{},
                job:null,
                userDateFormat: null,
                userTimeFormat:null,
                selectedEmployeeID: null,
                scrollType: null,
                isPaginationChange: false,
                scrollDirection: null
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                return("desktop" != check ? !0 : !1);
            },
        },

        methods: {
            async checkStewardSkill(){
                this.isSteward = 0;
                await service
                .get("employee/" + this.employeeId + "/checkSkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                })
                .then((res) => {
                    this.isSteward = res.data.result;
                    this.$forceUpdate();
                    return this.isSteward;
                })
                .catch((err) => {
                    this.isSteward = 0;
                    this.$Progress.fail();
                    return this.isSteward;
                });
            },
            getEmpDetails() {
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                }).catch((err) => {
                    console.log(err);
                });
            },
            onKeyDown(e){
                this.onPageChangeScroll();
            },
            getStatusName(name){
                let temp = name.substring(0, 3);
                return temp.toUpperCase();
            },            
            // onPageChangeScrollUp(){
            //     if(this.isFirstPageLoad && this.employees.length && this.currentPage>1){
            //         this.lastLoadedPage = this.currentPage;
            //         this.currentPage = this.currentPage-1;
            //         this.isFirstPageLoad = false;
            //         setTimeout(()=>{
            //             this.isFirstPageLoad = true;
            //         }, 200);
            //         this.scrollType = "up";
            //     }
            // },
            // onPageChangeScrollDown(){
            //     let total = this.totalLimit/this.pageSize;
            //     if(this.isFirstPageLoad && this.employees.length && this.currentPage<=total){
            //         this.lastLoadedPage = this.currentPage;
            //         this.currentPage = this.currentPage+1;
            //         this.isFirstPageLoad = false;
            //         setTimeout(()=>{
            //             this.isFirstPageLoad = true;
            //         }, 200);
            //     }
            // },
            //  onPageChange(val){
            //     const isMobile = this.deviceDetector;
            //     let tempEmpList = this.storeMore;
            //     let buffer = isMobile ? 6 : 4;
            //     let end = (this.pageSize * this.currentPage);
            //     let start = end - this.pageSize;

            //     start = start - buffer;
            //     if(start < 0){
            //         start = 0
            //     }
            //     end = end + buffer;

            //     if(end > this.totalLimit){
            //         end =  this.totalLimit;
            //     }

            //     this.employees = this.storeMore.slice(start, end-1);
                                    
            //     if(this.currentPage >= this.lastLoadedPage){
            //         $('#page-data-focus').scrollTop($('#scrollTop2').scrollTop());
            //         this.lastLoadedPage = this.currentPage;
            //         if(this.currentPage == this.lastLoadedPage){                  
            //             this.employees = this.storeMore.slice(start, end+1);
            //         }
            //     }else{
            //         let last_position = this.totalLimit % this.pageSize;                    
            //         let position = "";                    
            //         if(this.scrollType == 'up' && this.lastLoadedPage == Math.ceil(this.totalLimit/this.pageSize)) {
            //             position = $('#scrollTop'+last_position).offset();
            //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop'+last_position).scrollTop());
            //         } else {
            //             position = $('#scrollTop98').offset();
            //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop98').scrollTop());
            //         }
            //         this.lastLoadedPage = this.currentPage;
            //     }
            //     this.scrollType = null;                
            // },
            
            onPageChangeScrollUp(){
                if (this.loading || this.ignoreScrollEvents) return;
                if (this.currentPage <= 1) return; // first page
                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = 'up';
                this.currentPage--;
                this.updatePagedData();
                this.loading = false;
            },

            updatePagedData() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;

                if (this.isPaginationChange) {
                    // On pagination click, replace with new slice
                    this.employees = this.storeMore.slice(start, end);
                } else if (this.scrollDirection === 'down') {
                    const newItems = this.storeMore.slice(start, end);

                    // Filter to only add items not already present
                    const existingIds = new Set(this.employees.map(e => e.id));
                    const filteredNewItems = newItems.filter(item => !existingIds.has(item.id));

                    // Only concat if there are new items (protects against double fire at last page)
                    if (filteredNewItems.length > 0) {
                    this.employees = this.employees.concat(filteredNewItems);
                    }
                    // Else: do NOT modify employees, prevents duplicates
                } else if (this.scrollDirection === 'up') {
                    // Only implement if you use upward infinite scroll
                    // ...similar logic as above, with prepending
                }

                this.isPaginationChange = false;
                this.scrollDirection = null;
            },
            
            onPageChangeScrollDown(){
                if (this.loading) return;

                // Compute total number of pages:
                const totalPages = Math.ceil(this.totalLimit / this.pageSize);
                if (this.currentPage >= totalPages) return; // do NOT increment past last page

                this.loading = true;
                this.scrollDirection = 'down';
                this.isPaginationChange = false;
                this.currentPage++;
                this.updatePagedData();
                this.loading = false;
            },

            onPageChange(page){
                if (this.loading) return;

                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = null;
                this.currentPage = page;
                // Ignore scroll events during programmatic scrollTop setting
                this.ignoreScrollEvents = true;

                this.updatePagedData();

                this.$nextTick(() => {
                    if (this.$refs.scrollContainer) {
                        this.$refs.scrollContainer.$refs.container.scrollTop = 0;
                    }
                    setTimeout(() => {
                        this.ignoreScrollEvents = false; // re-enable scroll handling after short delay
                    }, 100);
                    
                    this.loading = false;
                });
            },
            
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },            
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            // decline Call
                            case 'Declined':
                                declines.push(call);
                            break;
                            // pass call
                            case 'Passed':
                                passes.push(call);
                            break;
                            // call out
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            // Call time out
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    // decline Call
                    case 'Declined':
                        return declines;
                    break;
                    // pass call
                    case 'Passed':
                        return passes;
                    break;
                    // call out
                    case 'Call Out':
                        return callouts;
                    break;
                    // Call time out
                    case 'Timed Out':
                        return timeouts;
                    break;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            bulkAssign() {
                this.$router.push('bulkAssign');
            },
            employeeSummary() {
                this.$modal.show('employeeSummary');
            },
            hideModal() {
                this.$modal.hide('employeeSummary');
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'MMMM D, YYYY');
            },

            checkThisClickCooking(bookings){
                let status = false;
                for(let i=0; i<bookings.length; i++){
                    if(bookings[i].client_id == this.userClientID) {
                        status = true;
                    }
                }
                return status;
            },
           
            async getEmployeesForAllSkills() {
                this.employees=[];
                this.storeMore=[];
                this.loading=true;
                this.apiData=false;
                this.$Progress.start();
                await service.get('call/getEmployeesByEmployeeListForDailySchedule', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'search': this.search,
                    'dates': moment(this.date,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
                    'skills': this.skills,
                    'status': this.status,
                    'sort': this.sort
                })
                .then((res) => {
                    this.loading=false;
                    this.apiData=true;
                    this.nextPageUrl = null;
                    this.storeMore= res.data.result;
                    this.totalLimit = res.data.result?res.data.result.length:0;
                    this.currentPage = 1;
                    if(this.totalLimit <= this.pageSize){
                        this.employees = this.storeMore;
                    }else{
                        // this.onPageChange(1);
                        this.updatePagedData();
                    }
                    setTimeout(()=>{
                        this.isFirstPageLoad = true;
                    }, 5000);
                    this.$Progress.finish();
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.apiData=true;
                });
            },

            recurringUnavailabilityCheck(unavailability_list) {
                let flag = false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            console.log(unavailabilityList1[j]);
                            var temp = unavailabilityList1[j];
                            
                            var unavailabilityStart = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var unavailabilityEnd = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                            
                            let isOverNightUnavailability = moment(unavailabilityStart,'YYYY-MM-DD HH:mm:ss').isAfter(moment(unavailabilityEnd,'YYYY-MM-DD HH:mm:ss'));
                            if(isOverNightUnavailability) {
                                console.log("check0");
                                if(unavailabilityStart.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {  //Check same date or not
                                    unavailabilityEnd = moment(unavailabilityStart, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");  // add 1 day
                                }
                                console.log(weekDaysNames[i]);
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) || (moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1])) {
                                    if(this.callStartTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check1");
                                        console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }else if(this.callStartTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check2");
                                        console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    } else if(this.callEndTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check3");
                                        console.log(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }else if(this.callEndTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check4");
                                        console.log(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }
                                }
                                console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                console.log("Conditions failed");
                            }
                        }
                    }
                }
                // HillsPU
                return flag
            },

            recurringUnavailability(unavailability_list) {
                var flag=false;               
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {  
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
        
                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;
                                
                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                                
                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                
                                if(flag){ return flag; }
                               
                            }else {
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    let day1CallStart = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    
                                    let tempDay2CallStart =  moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'); 
                                    
                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        if(flag) return flag;
                                    }
                                }
                            }

                        }
                    }
                }
                return flag;
            },

            checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    
                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'); 
                    
                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    console.log(day, start, end, callStartTime, callEndTime);
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){        
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');
                                       
                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];  
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';                                               
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';                                                  
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },

            checkVacationWithinCall(vacations) {
                if(vacations.length>0){
                    
                    return true;
                }
                return false;
            },
            
            sortDynamic(type){
                switch(type){
                    case "employee_name":
                        if(this.selectedSortType=='fname_asc'){
                            this.selectedSortType='fname_desc';
                        }else{
                            this.selectedSortType='fname_asc';
                        }
                        break;

                    case "skill_seniority":
                        if(this.selectedSortType=='skill_seniority'){
                            this.selectedSortType='skill_seniority_desc';
                        }else{
                            this.selectedSortType='skill_seniority';
                        }
                        break;

                    case "employee_seniority":
                        if(this.selectedSortType=='emp_seniority'){
                            this.selectedSortType='emp_seniority_desc';
                        }else{
                            this.selectedSortType='emp_seniority';
                        }
                        break;

                    case "shift_count_total":
                        if(this.selectedSortType=='shift_total_asc'){
                            this.selectedSortType='shift_total_desc';
                        }else{
                            this.selectedSortType='shift_total_asc';
                        }
                        break;

                    case "shift_count_ytd":
                        if(this.selectedSortType=='shift_YTD_asc'){
                            this.selectedSortType='shift_YTD_desc';
                        }else{
                            this.selectedSortType='shift_YTD_asc';
                        }
                        break;

                    case "shifts_this_week":
                        if(this.selectedSortType=='shift_weekly_asc'){
                            this.selectedSortType='shift_weekly_desc';
                        }else{
                            this.selectedSortType='shift_weekly_asc';
                        }
                        break;

                    case "shifts_ytd_july_june":
                        if(this.selectedSortType=='shift_july_june_asc'){
                            this.selectedSortType='shift_july_june_desc';
                        }else{
                            this.selectedSortType='shift_july_june_asc';
                        }
                        break;

                    case "declines_total":
                        if(this.selectedSortType=='decline_total__asc'){
                            this.selectedSortType='decline_total__desc';
                        }else{
                            this.selectedSortType='decline_total__asc';
                        }
                        break;

                    case "declines_ytd":
                        if(this.selectedSortType=='decline_YTD_asc'){
                            this.selectedSortType='decline_YTD_desc';
                        }else{
                            this.selectedSortType='decline_YTD_asc';
                        }
                        break;

                    case "declines_ytd_july_june":
                        if(this.selectedSortType=='decline_july_june_asc'){
                            this.selectedSortType='decline_july_june_desc';
                        }else{
                            this.selectedSortType='decline_july_june_asc';
                        }
                        break;

                    case "decline_this_week":
                        if(this.selectedSortType=='decline_weekly_asc'){
                            this.selectedSortType='decline_weekly_desc';
                        }else{
                            this.selectedSortType='decline_weekly_asc';
                        }
                        break;
                    
                    case "employee_cell_phone":
                        if(this.selectedSortType=='phone_asc'){
                            this.selectedSortType='phone_desc';
                        }else{
                            this.selectedSortType='phone_asc';
                        }
                        break;
        
                    case "conflicts":
                        if(this.selectedSortType=='conflicts_asc'){
                            this.selectedSortType='conflicts_desc';
                        }else{
                            this.selectedSortType='conflicts_asc';
                        }
                        break;

                    case "location":
                        if(this.selectedSortType=='location_asc'){
                            this.selectedSortType='location_desc';
                        }else{
                            this.selectedSortType='location_asc';
                        }
                        break;

                    case "participation":
                        if(this.selectedSortType=='participation_asc'){
                            this.selectedSortType='participation_desc';
                        }else{
                            this.selectedSortType='participation_asc';
                        }
                        break;

                    case "participation_july_june_desc":
                        if(this.selectedSortType=='participation_july_june_desc'){
                            this.selectedSortType='participation_july_june_asc';
                        }else{
                            this.selectedSortType='participation_july_june_desc';
                        }
                        break;

                    case "wishlist":
                        if(this.selectedSortType=='wishlist_asc'){
                            this.selectedSortType='wishlist_desc';
                        }else{
                            this.selectedSortType='wishlist_asc';
                        }
                        break;

                    case "custom_field1":
                        if(this.selectedSortType=='custom_field1_asc'){
                            this.selectedSortType='custom_field1_desc';
                        }else{
                            this.selectedSortType='custom_field1_asc';
                        }
                        break;

                    case "custom_field2":
                        if(this.selectedSortType=='custom_field2_asc'){
                            this.selectedSortType='custom_field2_desc';
                        }else{
                            this.selectedSortType='custom_field2_asc';
                        }
                        break;
                } 
                this.getEmployeesForAllSkills();
            },

            
            pollData () {   
                this.polling = setInterval(() => {
                        if(document.visibilityState === 'visible'){
                            this.timerState = "Started"
                        }else {
                            this.timerState = "Paused"
                        }
                
                    if (this.timerState === "Started") {
                        this.getEmployeesForAllSkills();
                    }
                }, 60000);
            },
            async getClient(){
              await service.get('client/' + this.userClientID, {
                  'Authorization': this.userToken
              }).
              then((res) => {
                  this.client = res.data.result;
                  this.customField1 = this.client.custom_field_1;
                  this.customField2 = this.client.custom_field_2;
                  this.showCustom = this.client.employee_title;
                  this.selectedSortType = this.client.default_sort != '' ? this.client.default_sort : 'fname_asc';
                  this.callAssignmentSettings = this.client.settings['call-assignment-config'];
                  let phoneIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'employee_cell_phone');
                  if(phoneIndex < 0) {
                    this.callAssignmentSettings.push('employee_cell_phone');
                  }
                  let wishListConfigIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'wishlist');
                  if(wishListConfigIndex>-1) {
                    this.callAssignmentSettings.splice(wishListConfigIndex, 1);
                  }
                  let skillSeniorityConfigIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'skill_seniority');
                  if(wishListConfigIndex>-1) {
                    this.callAssignmentSettings.splice(skillSeniorityConfigIndex, 1);
                  }
              }).catch((err) => {
                  console.log(err);
              }); 
            }       
        },

        async created() {
            this.getBaseURL = global[0].IMAGE_URL;
            await this.getClient();
        },
        
        async mounted(){
            await this.getEmployeesForAllSkills();
            let self = this;
            $(window).on('keydown', function(e) {
                if(e.keyCode === 40){
                    document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollDown();
                }else if(e.keyCode === 38){
                    document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollUp();
                }
            });
            var totalHeight = $('.o-header').height() + $('.table_header_wrapper').height()+100;
            var windowHeight = $(window).height();
            var adjustedHeight = windowHeight - totalHeight;
            if(adjustedHeight<250){
              $('.tbl-content').css('height', 200);
            }else{
              $('.tbl-content').css('height', adjustedHeight);
            }
            $("#fc_frame").css('display', 'none');
        },

        watch: {
            async date() {
                if(this.componentName=='AllEmployees') {
                    await this.getEmployeesForAllSkills();
                }
            },
            async search() {
                if(this.componentName=='AllEmployees'&&(this.search.length==0||this.search.length>=3)) {
                    await this.getEmployeesForAllSkills();
                }
            },
            async sort() {
                if(this.componentName=='AllEmployees') {
                    await this.getEmployeesForAllSkills();
                }
            } 
        },


        beforeDestroy(){
            $("#fc_frame").css('display', 'block');
            $(window).off('keydown');
            $('.v--modal-overlay.scrollable').css('overflow-y','auto');
        },

    }
    

</script>
<style scoped>
.el-pagination-assign {
    max-width: 3%!important;
    width: 3%!important;
}
.v--modal-overlay.scrollable{
    overflow-y: auto!important;
}
.o-common-modal-content {
    border-radius: 3px !important;
    padding: 0px!important;
    background-color: #ffffff;
    border: 2px solid #000000!important;
}

.modal-title {
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    background-color: #F67801;
    border-bottom: 2px solid #000000;
}

.close {
    text-shadow: 0 0 0 #000000!important;
    font-size: 15px;
}

.custom-modal--close {
    opacity: 1;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    background-color: #F67801!important;
    color: #000000!important;
    padding: 0 !important;
    text-shadow: #000000!important;
    margin-top: 0;
}

.obt-modal-cancel-btn {
    background-color: #F67801;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.obt-modal-proceed-btn {
    background-color: #17A068;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}

.obt-conflict-body {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 10px 0;
}

.display-inline{
    display: flex;
}

.global-skill-display {
    font-size: 13px;
    font-weight: 500;
    width: 24px;
    height: 24px;
    color: #000;
    background-color: #F67801;
    text-align: center;
}

#assign-emp-search:focus {
    border: 2px solid #337ab7;
}
#assign-emp-sort:focus {
    border: 2px solid #337ab7;
}
#selectedStatus:focus {
    border: 2px solid #337ab7;
}
.select_margin_adjust{
    width: 230px;   
}
.table_tagline p {
    font-size: 18px;
}

</style>
